import { FC, forwardRef, useId } from "react";

/**
 * Using for styled Icon.
 *
 * @template T - The props type of the icon component
 * @param Icon - The icon component to wrap
 * @returns A forwarded ref component with the same props as the original icon
 *
 * @example
 * ```tsx
 * import { Check } from "@tamagui/lucide-icons";
 * import { styled } from "tamagui";
 *
 * const CheckIcon = styled(withIconRef(Check), {
 *  name: "CheckIcon",
 *  variants: {
 *    variant: {
 *      default: {},
 *    },
 *  },
 * });
 * ```
 */
export const withIconRef = <T,>(Icon: FC<T>) =>
  forwardRef<any, T>((props, _ref) => {
    const key = useId();
    return <Icon {...props} key={key} />;
  });
